"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogTitle = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = require("styled-components");
const dialog_title_styles_1 = require("./dialog-title.styles");
const DialogTitle = ({ title, subtitle = '', onClose }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(dialog_title_styles_1.StyledDialogTitle, null, react_1.default.createElement("div", { className: "title-text" }, `${title}${subtitle && ` (${subtitle})`}`), react_1.default.createElement(material_1.IconButton, { "aria-label": "close", size: "small", onClick: onClose }, react_1.default.createElement(ui_components_1.Icon, { variant: "cancel", color: theme.palette.delete.main }))));
};
exports.DialogTitle = DialogTitle;
exports.default = exports.DialogTitle;
